import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import  tokenSlice  from "../features/authSlice";
// import userSlice from "../features/userSlice";

export const store = configureStore({
  reducer: {
    auth: tokenSlice,
  },
});

setupListeners(store.dispatch);
